export default class AnimateOnScroll extends HTMLElement {
  private observer: IntersectionObserver;
  private animatedElements: NodeListOf<HTMLElement>;
  private animationQueue: HTMLElement[] = [];
  private isAnimating: boolean = false;
  private cascadeDelay: number = 50;

  constructor() {
    super();

    requestAnimationFrame(() => {
      this.init();
    });
  }

  private init(): void {
    this.animatedElements = this.querySelectorAll("[scroll-animate-item]");

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const element = entry.target as HTMLElement;
          this.observer.unobserve(element);

          // Ajouter l'élément à la file d'attente
          this.animationQueue.push(element);

          // Démarrer la cascade si elle n'est pas déjà en cours
          if (!this.isAnimating) {
            this.processNextAnimation();
          }
        }
      });
    }, options);

    this.animatedElements.forEach((element) => {
      this.observer.observe(element);
    });
  }

  private processNextAnimation(): void {
    if (this.animationQueue.length === 0) {
      this.isAnimating = false;
      return;
    }

    this.isAnimating = true;
    const element = this.animationQueue.shift()!;

    // Calcul des délais
    const userDelay = parseInt(element.dataset.scrollAnimateDelay || "0");
    const currentIndex = Array.from(this.animatedElements).indexOf(element);
    const cascadeOffset = currentIndex * this.cascadeDelay;

    // Le délai total est la somme du délai utilisateur et du délai en cascade
    const totalDelay = userDelay + cascadeOffset;

    // Appliquer le délai
    element.style.transitionDelay = `${totalDelay}ms`;

    // Déclencher l'animation
    element.classList.add("active");

    // Attendre avant de passer au suivant
    setTimeout(() => {
      this.processNextAnimation();
    }, this.cascadeDelay); // On utilise uniquement le cascadeDelay pour la file d'attente
  }

  disconnectedCallback(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.animationQueue = [];
    this.isAnimating = false;
  }
}
